<template>
  <div>
    <Head
      :keyword="query.keyword"
      :state="query.state"
      :from="query.from"
      :to="query.to"
      @handleQuery="handleQuery"
      @handleRefresh="handleRefresh" />
    <Table
      :tableData="pageData.data"
      :editable="editable"
      @handlePreview="handlePreview"
      @handleRefresh="handleRefresh" />
    <Pagination
      :query="query"
      :pageData="pageData"
      @handleQuery="handleQuery"
      @handleRefresh="handleRefresh" />
    <FullScreenDialog
      type="contact"
      :visible="showPreview"
      :contain="previewContent"
      @toggleDialog="toggleDialog" />
  </div>
</template>

<script>
import { forIn, has } from 'lodash'
import resStatus from '@/constants/resStatus'
import { contactList } from '@/api/admin/contact'
import { adminLogout } from '@/utils/admin'

import Head from './Head'
import Table from './Table'
import Pagination from '@/components/admin/pagination'
import FullScreenDialog from '@/components/admin/full-screen-dialog'

export default {
  components: {
    Head,
    Table,
    Pagination,
    FullScreenDialog,
  },
  data () {
    return {
      query: {
        page: 1,
        pageSize: 10,
        keyword: '',
        from: '',
        to: '',
        state: '',
      },
      editable: true,
      pageData: {
        data: []
      },
      showPreview: false,
      previewContent: null
    }
  },
  methods: {
    init () {
      contactList(this.query).then(res => {
        switch (res.status) {
          case resStatus.OK:
            this.pageData = res
            break
          default:
            adminLogout()
            this.$message.error(res.message)
        }
      }).catch(err => {
        adminLogout()
        this.$message.error(err)
      })
    },
    handleQuery (obj) {
      forIn(obj, (val, key) => {
        if (has(this.query, key)) {
          this.query[key] = val
        }
      })
    },
    handleEditable (boo) {
      this.editable = boo
    },
    handleRefresh () {
      this.init()
    },
    handlePreview (obj) {
      this.previewContent = obj
      this.showPreview = true
    },
    toggleDialog (boo) {
      this.showPreview = boo
    }
  },
  created () {
    this.init()
  },
  watch: {
    $route (to, from) {
      this.init()
    }
  }
}
</script>
